import { trackImmediately } from './mixpanel';

const PENDING_KEY = 'spotlight_auth_attempt_v2';
const finishedAttempts = new WeakSet();
export const newAnalyticsId = () => window.crypto?.randomUUID?.()
  || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export const authReason = (error) => {
  const status = error?.status || error?.response?.status;
  if (status === 401 || status === 404) return 'invalid_credentials';
  if (status === 412) return 'verification_required';
  if (status === 422) return 'validation';
  if (status === 429) return 'rate_limited';
  if (status >= 500) return 'server';
  if (error?.code === 'ECONNABORTED') return 'timeout';
  if (status === 0 || error?.message === 'Network Error') return 'network';
  return 'unknown';
};

export const hasAuthenticatedUser = (user) => Boolean(
  user?.id != null && user?.email && user?.guest !== true
  && user?.['registered?'] !== false && user?.registered !== false,
);

export const beginAuthAttempt = (flow, method) => {
  const attempt = {
    flow, method, flow_id: newAnalyticsId(), attempt_id: newAnalyticsId(), started_at: Date.now(),
  };
  trackImmediately('auth_attempt_started', {
    ...attempt,
    schema_version: 2,
    $insert_id: `${attempt.attempt_id}:started`,
    time: Math.floor(attempt.started_at / 1000),
  });
  return attempt;
};

export const finishAuthAttempt = (attempt, outcome, reason = 'unknown') => {
  if (!attempt || finishedAttempts.has(attempt)) return;
  // Dedup repeated callbacks within the same attempt. Transport retries retain insert ID.
  finishedAttempts.add(attempt);
  trackImmediately('auth_attempt_result', {
    flow: attempt.flow,
    method: attempt.method,
    flow_id: attempt.flow_id,
    attempt_id: attempt.attempt_id,
    outcome,
    reason_code: ['success', 'guest'].includes(outcome) ? null : reason,
    duration_ms: Math.max(0, Date.now() - attempt.started_at),
    schema_version: 2,
    $insert_id: `${attempt.attempt_id}:result`,
    time: Math.floor(Date.now() / 1000),
  });
};

export const beginOAuthAttempt = (method) => {
  const attempt = beginAuthAttempt(window.location.pathname === '/signup' ? 'signup' : 'signin', method);
  try {
    window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(attempt));
  } catch { /* Optional correlation only. */ }
};

export const takeOAuthAttempt = () => {
  try {
    const raw = window.sessionStorage.getItem(PENDING_KEY);
    window.sessionStorage.removeItem(PENDING_KEY);
    const attempt = JSON.parse(raw || 'null');
    if (!attempt || !['google', 'apple'].includes(attempt.method)
      || !['signup', 'signin'].includes(attempt.flow)
      || !/^[a-zA-Z0-9-]{1,100}$/.test(attempt.attempt_id || '')
      || !/^[a-zA-Z0-9-]{1,100}$/.test(attempt.flow_id || '')
      || !Number.isFinite(attempt.started_at)
      || Date.now() - attempt.started_at > 24 * 60 * 60 * 1000
      || attempt.started_at > Date.now()) return null;
    return attempt;
  } catch { return null; }
};
